import React from 'react'
import './HomeContact.css'
import {LocationOn,Call,Email} from '@material-ui/icons';
import Button from '../Button/Button';

const HomeContact = () => {
    return (
        <div className="home-contact" id="contact-us">
            <h1 className="home-contact-heading">CONTACT US</h1>
            <div className='home-contact-container'>
                <div className="home-contact-box left-box">
                    <div className="home-contact-info-box">
                        <LocationOn className="home-contact-icon" fontSize="large"/>
                        <p >
                        SWAB NANOSOLUTIONS PRIVATE LIMITED<br></br>
                        Khasra NO. 38/10, Vill: Mundka, Near Mundka Metro Yard<br></br>
                        New Delhi, Delhi<br></br>
                        110041, India</p>
                    </div>
                    <div className="home-contact-info-box">
                        <Call className="home-contact-icon" fontSize="large"/>
                        <p>+91 8839331739<br></br>+91 8383895012</p>
                    </div>
                    <div className="home-contact-info-box">
                        <Email className="home-contact-icon" fontSize="large"/>
                        <p>swab.nanosolutions@gmail.com</p>
                    </div>
                </div>
                <div className="home-contact-box right-box">
                    <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                        <input className="home-contact-input width" placeholder="First Name" />
                        <input className="home-contact-input width" placeholder="Company Name"/>
                    </div>
                    <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                        <input className="home-contact-input width" placeholder="City"/>
                        <input className="home-contact-input width" placeholder="India(+91)"/>
                    </div>
                    <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                        <input className="home-contact-input" placeholder="Email Id"/>
                    </div>
                    <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                        <input className="home-contact-input" placeholder="Phone Number"/>
                    </div>
                    <Button buttonStyle="btn-primary" buttonSize="btn-large">SUBMIT</Button>
                    
                </div>
            </div>
            
        </div>
    )
}

export default HomeContact
